<ng-template appComponentHost></ng-template>

@for (
  subTreeCategoryWithProduct of treeCategoryWithProduct().children;
  track subTreeCategoryWithProduct.category.id
) {
  <app-category-factory
    [componentClass]="componentClass()"
    [treeCategoryWithProduct]="subTreeCategoryWithProduct"
    [isOrderingAllowed]="isOrderingAllowed()"
    [categoryNameColor]="categoryNameColor()"
    [categoryDescriptionColor]="categoryDescriptionColor()"
    [highlightCategoryNameColor]="highlightCategoryNameColor()"
    [highlightCategoryBackgroundColor]="highlightCategoryBackgroundColor()"
    [productNameColor]="productNameColor()"
    [productDescriptionColor]="productDescriptionColor()"
    [productPriceColor]="productPriceColor()"
    [productImagePlaceholderColor]="productImagePlaceholderColor()"
    [productBorderColor]="productBorderColor()"
    [productBackgroundColor]="productBackgroundColor()"
    [tagColors]="tagColors()"
    (navigateTo)="navigateTo.emit($event)"
  ></app-category-factory>
}
